import React from 'react';
import { forwardRefPolymorphic } from "@mrocket/utils";
import { HTMLBaseSystemProps, SizeName } from "@mrocket/styles";
import { PaperRoot } from "./Paper.styles";



export interface PaperProps extends HTMLBaseSystemProps<'div'> {
  withBorder?: boolean
  hovered?: boolean
  space?: SizeName | 'none'
}

/**
 * Paper component renders theme background with shadow, border-radius and appearance from theme.
 * */

export const Paper = forwardRefPolymorphic<
  'div',
  PaperProps
>((
  {
    appearance = 'default',
    radius = 'rounded',
    mode = 'secondary',
    hovered = false,
    withBorder = false,
    space = 'tiny',
    ...props
  } = {},
  ref
) => {

  return (
    <PaperRoot
      ref={ref}
      appearance={appearance}
      radius={radius}
      withBorder={withBorder}
      mode={mode}
      hovered={hovered}
      space={space}
      {...props}
    />
  );
})

